export const LOGO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_bf1754ea-d083-476d-92a0-46db17631076/artifacts/yzovkb0u_SpeedFreakes2-removebg-preview-ok.PNG";

const MONTHS_PT = [
  "JAN", "FEV", "MAR", "ABR", "MAI", "JUN",
  "JUL", "AGO", "SET", "OUT", "NOV", "DEZ",
];

const WEEKDAYS_PT_FULL = [
  "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado",
];

const WEEKDAYS_PT_SHORT = [
  "DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB",
];

export function formatDayOfWeek(isoStr, short = false) {
  const d = parseRideDate(isoStr);
  if (!d || isNaN(d)) return "";
  return short ? WEEKDAYS_PT_SHORT[d.getDay()] : WEEKDAYS_PT_FULL[d.getDay()];
}

export function formatDateWithWeekday(isoStr) {
  const d = parseRideDate(isoStr);
  if (!d || isNaN(d)) return "";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${WEEKDAYS_PT_FULL[d.getDay()]}, ${dd}/${mm}`;
}

export function parseRideDate(isoStr) {
  if (!isoStr) return null;
  return new Date(isoStr);
}

export function formatDatePt(isoStr) {
  const d = parseRideDate(isoStr);
  if (!d || isNaN(d)) return "--/--/----";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

export function formatDayMonth(isoStr) {
  const d = parseRideDate(isoStr);
  if (!d || isNaN(d)) return { day: "--", month: "---" };
  return {
    day: String(d.getDate()).padStart(2, "0"),
    month: MONTHS_PT[d.getMonth()],
    year: d.getFullYear(),
  };
}

export function formatTime(isoStr) {
  const d = parseRideDate(isoStr);
  if (!d || isNaN(d)) return "--:--";
  return d.toTimeString().slice(0, 5);
}

export function isPast(isoStr) {
  const d = parseRideDate(isoStr);
  if (!d) return false;
  return d.getTime() < Date.now();
}

export function buildWhatsAppShareText(ride, siteUrl) {
  const dt = parseRideDate(ride.ride_datetime);
  const dateStr = dt ? formatDatePt(ride.ride_datetime) : "";
  const timeStr = dt ? formatTime(ride.ride_datetime) : "";
  const lines = [
    `🏍️ ROLÊ SPEED FREAKS: ${ride.name}`,
    ``,
    `📍 Local: ${ride.location}`,
    ride.location_link ? `🔗 ${ride.location_link}` : null,
    ``,
    `📅 Data: ${dateStr}`,
    `🕒 Encontro: ${ride.arrival_time || timeStr}`,
    `⚠️ Saída: ${ride.departure_time} — Sem atrasos!`,
    ``,
    `🛵 Ponto de encontro: ${ride.meeting_point}`,
    ride.meeting_point_link ? `🗺️ ${ride.meeting_point_link}` : null,
    ``,
    siteUrl ? `👉 Confirme presença: ${siteUrl}` : null,
  ].filter(Boolean);
  return lines.join("\n");
}

export function buildRsvpListText(ride, rsvps) {
  const dateStr = formatDatePt(ride.ride_datetime);
  const lines = [
    `🏍️ CONFIRMADOS — ${ride.name} (${dateStr})`,
    `Total: ${rsvps.length}`,
    ``,
  ];
  rsvps.forEach((r, idx) => {
    const parts = [`${idx + 1}. ${r.rider_name}`];
    parts.push(`Moto: ${r.motorcycle_model}`);
    if (r.companion) parts.push(`+ ${r.companion}`);
    if (r.is_guest) parts.push(`(Convidado)`);
    lines.push(parts.join(" | "));
  });
  return lines.join("\n");
}

export function buildRecap24hText(ride, rsvps) {
  const dateStr = formatDatePt(ride.ride_datetime);
  const lines = [
    `⏰ RECAP 24H — ${ride.name}`,
    `Amanhã é dia! Sem atrasos.`,
    ``,
    `📅 ${dateStr}`,
    `🕒 Encontro: ${ride.arrival_time}`,
    `🏁 Saída: ${ride.departure_time}`,
    ``,
    `📍 Ponto de encontro: ${ride.meeting_point}`,
    ride.meeting_point_link ? `🗺️ ${ride.meeting_point_link}` : null,
    ``,
    `🎯 Destino: ${ride.location}`,
    ride.location_link ? `🔗 ${ride.location_link}` : null,
    ``,
    `👥 Confirmados: ${rsvps.length}`,
  ];
  rsvps.forEach((r, idx) => {
    const parts = [`${idx + 1}. ${r.rider_name}`];
    if (r.companion) parts.push(`+ ${r.companion}`);
    parts.push(`— ${r.motorcycle_model}`);
    if (r.is_guest) parts.push(`(convidado)`);
    lines.push(parts.join(" "));
  });
  lines.push(``, `🏍️ Bora Speed Freaks!`);
  return lines.filter((l) => l !== null).join("\n");
}

export function hoursUntil(isoStr) {
  const d = parseRideDate(isoStr);
  if (!d) return Infinity;
  return (d.getTime() - Date.now()) / (1000 * 60 * 60);
}

export function maskPhoneBR(value) {
  const digits = (value || "").replace(/\D/g, "").slice(0, 11);
  const len = digits.length;
  if (len === 0) return "";
  if (len <= 2) return `(${digits}`;
  if (len <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (len <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

export function downloadCsv(filename, rows) {
  const csv = rows
    .map((row) =>
      row
        .map((cell) => {
          const s = String(cell ?? "");
          if (s.includes(",") || s.includes('"') || s.includes("\n")) {
            return `"${s.replace(/"/g, '""')}"`;
          }
          return s;
        })
        .join(",")
    )
    .join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
